var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRankingActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 34.368,
    viewBox: "0 0 40 34.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 40,
    height: 34.368,
    transform: "translate(0 0)",
    fill: "#0c0c28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 40,
    height: 3.519,
    transform: "translate(0 30.849)",
    fill: "#0c0c28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M14.8,28.945H25.2V0H14.8ZM21.469,11.29H19.532V7.13a6.678,6.678,0,0,0-.046-1.086.408.408,0,0,0-.235-.275,2.373,2.373,0,0,0-.863-.091H18.2v-.9A3.521,3.521,0,0,0,20.33,3.532h1.139Z",
    fill: "#0c0c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M2.172,28.945h10.4V7.915H2.172ZM9.426,17.1v1.321H5.168V17.321c1.262-2.061,2.014-3.343,2.25-3.833a2.951,2.951,0,0,0,.36-1.145.786.786,0,0,0-.112-.471.409.409,0,0,0-.654.013,1.43,1.43,0,0,0-.111.687v.739H5.168V13.03A5.98,5.98,0,0,1,5.233,12a1.8,1.8,0,0,1,.334-.739,1.668,1.668,0,0,1,.686-.55,2.507,2.507,0,0,1,1.008-.19,2.394,2.394,0,0,1,1.746.576A1.929,1.929,0,0,1,9.6,12.552a3.4,3.4,0,0,1-.334,1.407A29.135,29.135,0,0,1,7.3,17.112H9.419Z",
    fill: "#0c0c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M27.421,28.938h10.4V14.469h-10.4ZM34.6,23.882a1.53,1.53,0,0,1-.726.778,3.488,3.488,0,0,1-2.774-.039,1.435,1.435,0,0,1-.686-.759,5.01,5.01,0,0,1-.164-1.556v-.615h1.936v1.262a2.125,2.125,0,0,0,.059.641.263.263,0,0,0,.268.138.286.286,0,0,0,.3-.171,3.292,3.292,0,0,0,.072-.9v-.537a1.638,1.638,0,0,0-.1-.654.478.478,0,0,0-.295-.268,2.982,2.982,0,0,0-.765-.072V20a4.035,4.035,0,0,0,.85-.052.36.36,0,0,0,.236-.229,1.637,1.637,0,0,0,.072-.556v-.432A1.071,1.071,0,0,0,32.8,18.2a.291.291,0,0,0-.262-.131.277.277,0,0,0-.275.137,1.42,1.42,0,0,0-.072.582v.635H30.253V18.76a1.814,1.814,0,0,1,.51-1.5,2.656,2.656,0,0,1,1.616-.393,2.511,2.511,0,0,1,1.877.543,2.159,2.159,0,0,1,.491,1.5,1.9,1.9,0,0,1-.177.942,1.606,1.606,0,0,1-.621.529,1.205,1.205,0,0,1,.654.484,3.56,3.56,0,0,1,.216,1.583,3.963,3.963,0,0,1-.209,1.433Z",
    fill: "#0c0c28"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingActive);
export default __webpack_public_path__ + "static/media/ranking-active.75bc29333b8e7db7e8f81fd5b1db8895.svg";
export { ForwardRef as ReactComponent };